import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/news";
import { formatViews, getCategoryByName } from "@/lib/news";

export default function NewsListItem({ news, index }: { news: NewsItem; index?: number }) {
  const cat = getCategoryByName(news.category);

  return (
    <Link
      to={`/detail/${news.id}`}
      className="group flex gap-4 border-b border-background-200 py-5 last:border-b-0"
    >
      {typeof index === "number" && (
        <span
          className={`mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
            index < 3 ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-700"
          }`}
        >
          {index + 1}
        </span>
      )}
      <div className="min-w-0 flex-1">
        <div className="mb-1.5 flex flex-wrap items-center gap-2">
          <span className="rounded bg-primary-50 px-2 py-0.5 text-xs font-medium text-primary-600">
            {cat ? cat.name : news.category}
          </span>
          <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700">{news.subCategory}</span>
        </div>
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
          {news.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-500">{news.summary}</p>
        <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {news.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {news.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(news.views)} 浏览
          </span>
        </div>
      </div>
      <div className="hidden h-24 w-36 shrink-0 overflow-hidden rounded-md bg-background-200 sm:block">
        <img
          src={news.cover}
          alt={`${news.title} - 91爆料热点新闻配图`}
          title={`${news.title} - 91爆料`}
          className="h-24 w-36 object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
    </Link>
  );
}